import { NonOptional } from '@tanium/coreui-utils';
import { Id } from '../../types/Id';
import {
  StackedRibbonListMinimalProps,
  StackedRibbonListMinimalVirtualizedProps,
  StackedRibbonListVirtualizedProps,
} from '../../types/StackedRibbonListComponentTypes';
import { useStackedRibbonList } from './useStackedRibbonList';

type VirtualizedStackedRibbonListProps<TId extends Id, TItem> = Omit<
  StackedRibbonListVirtualizedProps<TId, TItem>,
  'height'
>;

interface UseVirtualizedStackedRibbonListReturnType<TId extends Id, TItem>
  extends NonOptional<StackedRibbonListMinimalProps<TId, TItem>>,
    NonOptional<StackedRibbonListMinimalVirtualizedProps<TId, TItem>> {}

export const useVirtualizedStackedRibbonList = <TId extends Id, TItem>(
  props: VirtualizedStackedRibbonListProps<TId, TItem>,
): UseVirtualizedStackedRibbonListReturnType<TId, TItem> => {
  const ribbonListProps = useStackedRibbonList(props);

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { estimatedItemSize, loadMoreItems, minimumBatchSize, unstable_infiniteScrollItemCount } =
    props;

  return {
    ...ribbonListProps,
    estimatedItemSize,
    loadMoreItems,
    minimumBatchSize,
    unstable_infiniteScrollItemCount,
  };
};
